import React from "react";
import { Box, Button, SxProps } from "@mui/material";
import { useTranslations } from "hooks/useTranslations";
import { useNavigate } from "react-router-dom";

import { fadeInButtons } from "../animations.confirmation";
import { GraphicMessage } from "components/GraphicMessage/GraphicMessage";
import { NoBookingGraphic, CustomAnimation } from "@thekilroygroup/shared-ui";

interface IProps {
  mountDelay?: number;
}

export const BookingNotFound = (props: IProps) => {
  const { mountDelay = 0 } = props;
  const translations = useTranslations();
  const content = translations.translations.confirmationPage.bookingNotFound;
  const navigate = useNavigate();

  return (
    <CustomAnimation
      type="delayMount"
      timeout={1}
      delay={mountDelay}
      mountOnEnter={true}
    >
      <Box sx={sxStyles.noBookingWrapper}>
        <GraphicMessage title={content.title} subTitle={content.subtitle}>
          <NoBookingGraphic />
        </GraphicMessage>
        <CustomAnimation
          {...fadeInButtons}
          delay={350}
          style={{ width: "100%" }}
        >
          <Box sx={sxStyles.buttonWrapper}>
            <Button variant="contained" onClick={() => navigate("/")}>
              {content.searchFlightsButton}
            </Button>
            <Button
              variant="outlined"
              onClick={() =>
                (location.href =
                  translations.translations.domainInfo.kilroyFrontpageUrl)
              }
            >
              {content.goToWebsiteButton}
            </Button>
          </Box>
        </CustomAnimation>
      </Box>
    </CustomAnimation>
  );
};

const sxStyles: { [key: string]: SxProps } = {
  noBookingWrapper: {
    p: 3,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "center",
    maxWidth: "600px",
    textAlign: "center",
    m: "auto",
  },
  title: {
    color: "primary.main",
    m: 2,
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: { sm: "center" },
    width: "100%",
    "& button": {
      mt: 2,
      my: { sm: 2 },
      mx: { sm: 1 },
    },
  },
};
